import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { finalists } from "@/mocks/finalists";
import { testimonials } from "@/mocks/about";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  steady: "ri-subtract-line",
};

export default function RankingPreview() {
  const top = [...finalists].sort((a, b) => b.score - a.score).slice(0, 6);

  return (
    <section id="rank" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <SectionHeading
            eyebrow="排名速览"
            title="群众打分实时排名"
            desc="分数越高代表综合评价越好。排名的每一次变化，都来自网友的真实投票。"
            action={
              <Link
                to="/ranking"
                className="shrink-0 px-5 py-2.5 rounded-md bg-foreground-900 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-500 transition-colors cursor-pointer"
              >
                查看完整排名结果
              </Link>
            }
          />

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
            <ol className="lg:col-span-7 divide-y divide-background-200 border-t border-b border-background-200">
              {top.map((item, index) => (
                <li key={item.id} className="py-4 flex items-center gap-4">
                  <span
                    className={`shrink-0 w-9 h-9 rounded-md flex items-center justify-center font-heading text-lg ${
                      index < 3 ? "bg-accent-500 text-accent-950" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-medium text-foreground-950 truncate">{item.title}</h3>
                      <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                        {item.categoryName}
                      </span>
                    </div>
                    <div className="mt-2 h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${(item.score / 10) * 100}%` }}
                      />
                    </div>
                  </div>
                  <div className="shrink-0 text-right">
                    <p className="font-heading text-xl text-primary-600 leading-none">{item.score.toFixed(1)}</p>
                    <span className="mt-1 inline-flex items-center gap-0.5 text-xs text-foreground-500">
                      <i className={trendIcon[item.trend]} />
                      {item.rankChange === 0 ? "持平" : Math.abs(item.rankChange)}
                    </span>
                  </div>
                </li>
              ))}
            </ol>

            <div className="lg:col-span-5 flex flex-col gap-4">
              {testimonials.map((item) => (
                <blockquote
                  key={item.name}
                  className="rounded-lg border border-background-200 bg-background-100 p-5 flex-1 flex flex-col justify-between"
                >
                  <p className="text-sm leading-relaxed text-foreground-700">“{item.text}”</p>
                  <footer className="mt-4 flex items-center gap-3">
                    <span className="w-9 h-9 rounded-full bg-secondary-500 text-background-50 flex items-center justify-center text-sm font-bold">
                      {item.name.slice(-1)}
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                      <p className="text-xs text-foreground-500">{item.role}</p>
                    </div>
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}